import EmitEvent, {HT_RESIZE, PAGE_ENTER, SMOOTH_SCROLLING} from "../../../libs/emit-event";
import services from "../../../libs/services";
import {checkDeviceMobile, isScreenPc} from "../../../libs/helper";

export class FeatureCareers {
    constructor() {
        this.DOM = {main: document.querySelector('.js-featureCareers')};
        if (!this.DOM.main) return false;

        this.DOM.info = this.DOM.main.querySelector('.js-featureCareers_info');
        this.scrolling = this.scrolling.bind(this);
        this.pageEnter = this.pageEnter.bind(this);
        this.onResize = this.onResize.bind(this);

        this.bindEvent();
    }

    scrolling({instance}) {
        if (!isScreenPc()) return;
        this.stickyNumber = Math.abs(instance);
        if (this.stickyNumber < this.maxStiky) {
            this.DOM.info.style.transform = `translate3d(0, ${this.stickyNumber}px, 0)`;
        }
    }

    calcMaxSticky() {
        this.maxStiky = this.DOM.main.scrollHeight;
    }

    pageEnter() {
        this.calcMaxSticky();
    }

    onResize() {
        if (!isScreenPc()) {
            this.DOM.info.style.transform = null;
        } else {
            this.scrolling({instance: services.smooth_scrolling_instance});
        }
        this.calcMaxSticky();
    }

    bindEvent() {
        EmitEvent.on(PAGE_ENTER, this.pageEnter);
        EmitEvent.on(HT_RESIZE, this.onResize);
        EmitEvent.on(SMOOTH_SCROLLING, this.scrolling);
    }

    removeEvents() {
        if (!this.DOM.main) return;
        EmitEvent.off(PAGE_ENTER, this.pageEnter);
        EmitEvent.off(HT_RESIZE, this.onResize);
        EmitEvent.off(SMOOTH_SCROLLING, this.scrolling);
    }
}